import { useEffect, useState } from 'react';
import {
  Alert,
  AlertTitle,
  Box,
  Collapse,
  IconButton
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

import './AlertMessage.scss';

export const AlertMessageTypes = {
  ERROR: "error",
  WARNING: "warning",
  INFO: "info",
  SUCCESS: "success"
};

function AlertMessage({ show, type, title, message, handleCloseAlertMessage }) {
  const [open, setOpen] = useState(show);

  let timeoutCloseAlert = null;

  useEffect(() => {
    setOpen(show);
  }, [show]);

  useEffect(() => {
    return () => {
      clearTimeout(timeoutCloseAlert);
    }
  }, [timeoutCloseAlert]);

  function handleClose() {
    setOpen(false);
    timeoutCloseAlert = setTimeout(() => {
      handleCloseAlertMessage();
    }, 1000);
  }

  if (!message) return <></>;
  return (
    <Box
      className="alert-message"
      sx={{ width: '100%' }}>
      <Collapse in={open}>
        <Alert
          sx={{ mb: 2 }}
          severity={type}
          elevation={2}
          action={
            <IconButton
              aria-label="close"
              color="inherit"
              size="small"
              onClick={handleClose}
            >
              <CloseIcon fontSize="inherit" />
            </IconButton>
          }
        >
          {title && (
            <AlertTitle>{title}</AlertTitle>
          )}
          {message}
        </Alert>
      </Collapse>
    </Box>
  );
}

export default AlertMessage;
